module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/023-cocos-island-da7f3bce78ce8ba765086e3112f29913.svg";